import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';


@Component({
  selector: 'app-super-topup',
  templateUrl: './super-topup.component.html',
  styleUrls: ['./super-topup.component.css']
})
export class SuperTopupComponent implements OnInit {

  constructor(private route: ActivatedRoute, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    this.getUserDetailsFromSnapshot();
  }

  getUserDetailsFromSnapshot() {
  const queryParams = this.route.snapshot.queryParams;
  
  const data = {
    mobile: queryParams['mobile'] || '',
    prospectId: "",
    quoteId: "",
    rmId: "",
    product: 170,
    email: queryParams['email'] || '',
    name: queryParams['name'] || '',
    company: "",
    location: "India",
    designation: "",
    comment: "",
    partnerId: "1126",
    channel: "Partner",
    leadSource: "Super_Topup_Email",
    googleClickID: "",
    couponCode: ""
  };

  this.serviceURLService.superTopUpLeadCreation(data).subscribe({
    next: (successData: any) => {
      console.log("Prospect created successfully", successData);
    },
    error: (prospectError) => {
      console.error("Error creating prospect", prospectError);
    }
  });
}
}